import type { CSSProperties, ReactNode, Ref } from 'react';

import { twMerge } from 'tailwind-merge';

export interface ChartFrameProps {
  title?: string;
  subtitle?: string;
  headerActions?: ReactNode;
  settingsBar?: ReactNode;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
  chartAreaRef?: Ref<HTMLDivElement>;
}

/** Shared chrome wrapper (card outline, title, subtitle) for all chart types. */
export const ChartFrame = ({
  title,
  subtitle,
  headerActions,
  settingsBar,
  className,
  style,
  children,
  chartAreaRef,
}: ChartFrameProps) => (
  <div
    className={twMerge(
      'bg-white border border-navy-200 rounded-lg overflow-hidden',
      className
    )}
    style={style}
  >
    {settingsBar && (
      <div className="px-chart-frame-x py-1 border-b border-navy-200">
        {settingsBar}
      </div>
    )}
    <div ref={chartAreaRef} className="pt-chart-frame-x px-chart-frame-x pb-4">
      {(title || subtitle || headerActions) && (
        <div className="flex items-start justify-between gap-3 min-w-0">
          <div className="min-w-0">
            {title && (
              <h3 className="font-text text-xl font-bold text-gray-800 m-0 break-words">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="font-text font-normal text-gray-500 m-0 break-words">
                {subtitle}
              </p>
            )}
          </div>
          {headerActions && <div className="shrink-0">{headerActions}</div>}
        </div>
      )}
      {children}
    </div>
  </div>
);
